// /app.js
import { createApp } from 'vue';

import Carousel from './components/Carousel.vue';
import ModalForm from './components/ModalForm.vue';

const app = createApp({}); // корневой компонент не нужен

app.component('carousel', Carousel);
app.component('modal-form', ModalForm);

app.mount('#app');

requestAnimationFrame(() => {
    if (window.initFaq) window.initFaq();
    if (window.initProcess) window.initProcess();
    if (window.initAboutCounters) window.initAboutCounters();
    if (window.initMobileMenu) window.initMobileMenu();
});